export default __webpack_public_path__ + "static/media/cross.71c46d71.svg";